// src/pages/SensaphoneAccessoriesPage.jsx
import React from "react";
import PageBanner from "../components/common/PageBanner";
import SensaphoneAccessoriesList from "../components/products/sensaphone/SensaphoneAccessoriesList";
import BackToProductButton from "../components/products/BackToProductButton";
import ProductThemeShell from "../components/products/ProductThemeShell";

const safeTextLocal = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    return value.map((v) => safeTextLocal(v)).join(" ");
  }
  if (typeof value === "object") {
    if (Array.isArray(value.children)) {
      return value.children.map((child) => safeTextLocal(child)).join(" ");
    }
    if (typeof value.text === "string") return value.text;
  }
  return "";
};

const SensaphoneAccessoriesPage = ({ banner, category }) => {
  if (!category) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-gray-700 text-xl">Content not available.</p>
      </div>
    );
  }

  const bannerTitle = safeTextLocal(category.name) || "Sensaphone Accessories";
  const bannerImageUrl = banner?.image?.[0]?.url || banner?.url;
  const bannerTitleIsWhite = banner?.titleColorIsWhite ?? true;
  const accessoriesItems = category.cas_sensaphone_accessories_items || [];

  return (
    <ProductThemeShell>
      <div className="sensaphone-accessories-page min-h-screen">
        <PageBanner
          title={bannerTitle}
          titleColorIsWhite={bannerTitleIsWhite}
          imageUrl={bannerImageUrl}
          bannerHeightClass="h-56 sm:h-64 md:h-72 lg:h-80"
        />

        <section className="product-section-surface w-full py-12 md:py-16 lg:py-20">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="product-panel-elevated rounded-3xl shadow-2xl overflow-hidden">
              <div className="product-panel-header">
                <h2>{bannerTitle}</h2>
              </div>

              <SensaphoneAccessoriesList
                items={accessoriesItems}
                safeText={safeTextLocal}
              />
            </div>

            <BackToProductButton />
          </div>
        </section>
      </div>
    </ProductThemeShell>
  );
};

export default SensaphoneAccessoriesPage;
